<template>
    <button class="primary-button" @click="onClick" :data-is-active="isActive" :disabled="disabled" :data-variant="variant">
        <slot name="icon"></slot>
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: 'primaryButton',
    props: {
        isActive: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        variant: {
            type: String,
            default: 'solid' // 'solid' | 'outline'
        }
    },
    methods: {
        onClick() {
            this.$emit('click');
        }
    }
}
</script>

<style scoped>

.primary-button {
    appearance: none;
    border: none;
    outline: none;
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    padding: var(--spacing-sm) var(--spacing);
    font-family: var(--font-family-primary);
    font-size: var(--text-sm);
    font-weight: 500;
    color: var(--color-primary);
    border: 1px solid var(--color-gray);
    border-radius: var(--radius-sm);
    background-color: var(--color-gray);
    transition: all 0.2s ease;
    cursor: pointer;
    user-select: none;
    opacity: 1;
}

.primary-button[data-variant="outline"] {
    background-color: transparent;
    border: 1px solid var(--color-primary);
    color: var(--color-primary);
}

.primary-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.primary-button:hover:not(:disabled) {
    opacity: 0.8;
}

.primary-button:active:not(:disabled) {
    scale: 0.98;
}

.primary-button[data-is-active="true"] {
    background-color: var(--color-primary);
    color: var(--color-white);
}
</style>